<template>
  <div id="user-edit-tab-info">
    <!-- Content Row -->
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full">
        <!--<vs-switch color="dark" icon-pack="feather" vs-icon-on="icon-home" vs-icon-off="icon-user" v-model="iscompany">
        <span slot="on">COMPANY</span>
        <span slot="off">PERSON</span>
      </vs-switch>-->
        <!-- Le CUI se saisit après « Add More Info » (onglet complet) : on prévient
             dès la création — une société sans CUI est facturée en personne physique. -->
        <cui-notice :person="data_local" />

        <p v-if="iscompany">
          <vs-input class="w-full mt-4" label="Name *" v-model="data_local.company_name" v-validate="'required'"
            name="name" @input="checkTheName()" />
          <span class="text-danger text-sm" v-show="errors.has('name')">{{
            errors.first("name")
            }}</span>
          <span class="text-danger text-sm" v-show="similarityCheckFailed">
            Could not check for similar names. Retype the name to retry, or contact an administrator.
          </span>




          <vs-alert v-if="similaritiesNamed.length == 1" color="warning" title="Client with a potential similar name detected!" active="true"
            class="mt-12 mb-4">
             We have identified a name in our database that partially matches your input. To proceed, please contact an administrator for validation. As a Broker, validation is required if the client is already registered to ensure proper assignment. Thank you for your understanding.
          </vs-alert>
          <vs-alert v-if="similaritiesNamed.length > 1" color="warning" title="Client with a potential similar name detected!" active="true"
            class="mt-12 mb-4">
            We have identified a name in our database that partially matches your input. To proceed, please contact an administrator for validation. As a Broker, validation is required if the client is already registered to ensure proper assignment. Thank you for your understanding.
          </vs-alert>
          <!--
          <vs-table v-if="similaritiesNamed.length > 0" :data="similaritiesNamed" class="table-dark-inverted mt-2">
            <template slot="thead">
              <vs-th>Name</vs-th>
              <vs-th>Similarity</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>
                  {{ data[indextr].company_name }}
                </vs-td>
                <vs-td>
                  {{ Math.round(data[indextr].pct * 100, 0) }}%
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>-->
        </p>
        <p v-else>
          <vs-input class="w-full mt-4" label="Firstname *" v-model="data_local.firstname"
            v-validate="'required|alpha_spaces'" name="firstname" />
          <span class="text-danger text-sm" v-show="errors.has('firstname')">{{
            errors.first("firstname")
            }}</span>

          <vs-input class="w-full mt-4" label="Lastname *" v-model="data_local.lastname"
            v-validate="'required|alpha_spaces'" name="lastname" />
          <span class="text-danger text-sm" v-show="errors.has('lastname')">{{
            errors.first("lastname")
            }}</span>
        </p>
      </div>
    </div>
    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button v-if="isfromoperation" class="ml-auto" color="#333b34" @click="save_changes(true)"
            :disabled="!validateForm">Continue Operation</vs-button>
          <vs-button v-else class="ml-auto" color="#333b34" @click="save_changes(true)" :disabled="!validateForm">Quick
            Add</vs-button>
          <vs-button v-if="!isfromoperation" class="ml-8" color="success" @click="save_changes(false)"
            :disabled="!validateForm">Add More Info</vs-button>
        </div>
        <br />
      </div>
    </div>
  </div>
</template>

<script>
import modulePersonList from "@/store/people/modulePersonList.js";
import vSelect from "vue-select";
import CuiNotice from "@/components/efactura/CuiNotice.vue";
import axios from "@/axios.js";
import similarNameCheck from "@/mixins/similarNameCheck.js";

export default {
  mixins: [similarNameCheck],
  components: {
    vSelect,
    CuiNotice,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      data_local: JSON.parse(JSON.stringify(this.data)),
      iscompany: true,
      selected: [],
      isMounted: false,
      addNewDataSidebar: false,
      sidebarData: {},
      buttonSubmitOpen: false,
      state: {},
      isfromoperation: false,
    };
  },
  computed: {
    validateForm() {
      // Enregistrement seulement une fois le nom AFFICHÉ contrôlé, et sans
      // résultat : sinon validation par un administrateur.
      return !this.similarityPending && this.similaritiesNamed.length === 0 && (
        !this.errors.any() &&
        ((this.data_local.firstname && this.data_local.lastname) ||
          this.data_local.company_name)
      );
    },
    currentPage() {
      if (this.isMounted) {
        if (this.data_local.id) return this.$refs.table.currentx;
      }
      return 0;
    },
    queriedItems() {
      if (this.data_local.id)
        return this.$refs.table
          ? this.$refs.table.queriedResults.length
          : this.users.length;
    },
  },
  methods: {
    confirmDeleteRecord() {
      let namealert = null;
      if (!this.data_local.company_name)
        namealert = this.data_local.firstname + " " + this.data_local.lastname;
      else namealert = this.data_local.company_name;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm Disable",
        text: `You are about to disable ${namealert}`,
        accept: this.deleteRecord,
        acceptText: "Disable",
      });
    },
    confirmEnableRecord() {
      let namealert = null;
      if (!this.data_local.company_name)
        namealert = this.data_local.firstname + " " + this.data_local.lastname;
      else namealert = this.data_local.company_name;
      this.$vs.dialog({
        type: "confirm",
        color: "success",
        title: "Confirm Enable",
        text: `You are about to re-enable ${namealert}`,
        accept: this.enableRecord,
        acceptText: "Enable",
      });
    },
    enableRecord() {
      axios
        .post("/person/enable", { id: this.data_local.id })
        .catch((err) => {
          // `resolve` n'existe pas ici : ReferenceError avalee, echec invisible.
          console.error("user account:", err);
          const data = err && err.response && err.response.data;
          this.$vs.notify({
            color: "danger",
            title: "NOT saved",
            text: (data && (data.message || data.error)) || (err && err.message) ||
              "The server refused the change.",
            time: 12000,
          });
        });
      this.$router.push({ name: "people/people-list" });
      this.showEnableSuccess();
    },
    showEnableSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Person Enable",
        text: "The selected person was successfully enabled",
      });
    },
    deleteRecord() {
      axios
        .post("/person/disable", { id: this.data_local.id })
        .catch((err) => {
          // `resolve` n'existe pas ici : ReferenceError avalee, echec invisible.
          console.error("user account:", err);
          const data = err && err.response && err.response.data;
          this.$vs.notify({
            color: "danger",
            title: "NOT saved",
            text: (data && (data.message || data.error)) || (err && err.message) ||
              "The server refused the change.",
            time: 12000,
          });
        });
      this.$router.push({ name: "people/people-list" });
      this.showDeleteSuccess();
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Person Deleted",
        text: "The selected person was successfully deleted",
      });
    },
    capitalize(str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length);
    },
    save_changes(isquickadd) {
      let upperName = this.data_local.company_name.replace(
        /(^\w|\s\w)(\S*)/g,
        (_, m1, m2) => m1.toUpperCase() + m2.toLowerCase()
      );
      this.$vs.loading();
      const obj = {
        id: this.data_local.id,
        iscompany: this.iscompany,
        company_name: upperName,
        lastname: this.data_local.lastname,
        firstname: this.data_local.firstname,
        isactive: true,
      };
      {
        this.$store
          .dispatch("peopleList/createPersonBroker", obj)
          .then((response) => {
            this.$vs.loading.close();
            if (response.data.message === "Validation error") {
              this.$vs.notify({
                color: "warning",
                title: "Duplicate",
                text: "Person already exists!",
              });
            } else {
              this.$vs.notify({
                color: "success",
                title: "",
                text: "Person Correctly Added!",
              });
              if (isquickadd) {
                if (
                  localStorage.getItem(
                    "creating-operation-and-need-to-add-user"
                  )
                ) {
                  this.$router.push({
                    path: localStorage.getItem(
                      "creating-operation-and-need-to-add-user-page-source"
                    ),
                  });
                } else {
                  this.$router.push({
                    path: "/person/" + this.$store.state.peopleList.person.id,
                  });
                }
              } else {
                this.$router.push({
                  path:
                    "/person-edit/" + this.$store.state.peopleList.person.id,
                });
              }
            }
          })
          .catch((err) => {
            this.$vs.loading.close();
            this.$vs.notify({
              color: "alert",
              title: "An Error Occured!",
              text: "The person was NOT added, please contact your dev",
            });
          });
      }
    },
    addNewData() {
      if (this.data_local.id) {
        var idperson = this.data_local.id;
        this.sidebarData = { idperson };
        this.toggleDataSidebar(true);
      } else {
        this.$vs.notify({
          color: "warning",
          title: "Please Add Person",
          text: "You have to add person before adding new address",
        });
      }
    },
    showDeleteAddressSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Address Deleted",
        text: "The address was successfully deleted",
      });
    },
    deleteAddress(id) {
      const obj = {
        idaddress: this.addresstodelete,
        idperson: this.data_local.id,
      };
      if (!modulePersonList.isRegistered) {
        this.$store.registerModule("peopleList", modulePersonList);
        modulePersonList.isRegistered = true;
      }
      this.$store.dispatch("peopleList/removeAddress", obj).catch((err) => {
        console.error(err);
      });
      this.showDeleteAddressSuccess();
      const ItemIndex = this.data_local.addresses.findIndex(
        (p) => p.id === obj.idaddress
      );
      this.data_local.addresses.splice(ItemIndex, 1);
    },
    deleteAddressOne(id, place) {
      this.addresstodelete = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm Delete",
        text: `You are about to delete the address ${place}`,
        accept: this.deleteAddress,
        acceptText: "Delete Address",
      });
    },
    editData(data) {
      data.idperson = this.data_local.id;
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    },
    getActiveColors(status) {
      if (status === "true") return "primary";
      if (status === false) return "danger";
      return "warning";
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
  },
  mounted() {
    this.isMounted = true;
    if (localStorage.getItem("creating-operation-and-need-to-add-user")) {
      this.isfromoperation = true;
    }
  },
};
</script>
